import { render, staticRenderFns } from "./waiting-approval.vue?vue&type=template&id=d90748fa&scoped=true"
import script from "./waiting-approval.vue?vue&type=script&lang=ts"
export * from "./waiting-approval.vue?vue&type=script&lang=ts"
import style0 from "./waiting-approval.vue?vue&type=style&index=0&id=d90748fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90748fa",
  null
  
)

export default component.exports